import { render, staticRenderFns } from "./CardTeacherAndStaff.vue?vue&type=template&id=71fbbcce"
import script from "./CardTeacherAndStaff.vue?vue&type=script&lang=js"
export * from "./CardTeacherAndStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports